import PropTypes from '../../_util/vue-types';
import { initDefaultProps } from '../../_util/props-util';
import { filterOption as defaultFilterOption, validateSearch as defaultValidateSearch, } from './util';
import { tuple } from '../../_util/type';
export const PlaceMent = tuple('top', 'bottom');
export const mentionsProps = {
    autofocus: PropTypes.looseBool,
    prefix: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    prefixCls: PropTypes.string,
    value: PropTypes.string,
    disabled: PropTypes.looseBool,
    split: PropTypes.string,
    transitionName: PropTypes.string,
    placement: PropTypes.oneOf(PlaceMent),
    character: PropTypes.any,
    characterRender: PropTypes.func,
    filterOption: {
        type: [Boolean, Function],
    },
    validateSearch: PropTypes.func,
    getPopupContainer: {
        type: Function,
    },
    options: {
        type: Array,
        default: () => undefined,
    },
    loading: PropTypes.looseBool,
    rows: [Number, String],
    direction: { type: String },
};
export const vcMentionsProps = Object.assign({}, mentionsProps);
export const defaultProps = {
    prefix: '@',
    split: ' ',
    rows: 1,
    validateSearch: defaultValidateSearch,
    filterOption: (() => defaultFilterOption),
};
export default initDefaultProps(vcMentionsProps, defaultProps);
